import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Console } from 'console';
import { AccountService } from 'src/app/services/account.service';
import { ChangeFormStatusComponent } from './change-form-status/change-form-status.component';
import { CreateConsentFormComponent } from './create-consent-form/create-consent-form.component';

@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.css']
})
export class ConsentFormComponent implements OnInit {
  formList: any;
  accountId: any;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  status = 'Disable';
  question_details: any;
  accountList: any;
  isConsentFormEnabled: boolean;
  constructor(private accountService: AccountService,
    private dialog: MatDialog,
    private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.route.parent.params.subscribe(params => {
      this.accountId = params['id'];
      this.getAccountDetailsById();
      this.getConsentForm()
    });
  
  }
  getAccountDetailsById() {
    this.accountService.getAccountDetailsById(this.accountId)
      .subscribe(
        res => {
          this.accountList = res;   
        }
      );
  }
  getConsentForm() {
    this.accountService.getConsentFormList(this.accountId)
      .subscribe(
        res => {
          this.formList = res;
        }
      );
  }
  changeSettings(e) {
    console.log(e.source.checked)
    if (e.source.checked === true) {
      this.status = 'Enable';
      this.api_error = '';
      this.api_success = '';
      this.disableConfirmbtn = true;
      this.accountService.changeFormSettings(this.accountId, this.status)
        .subscribe(
          data => {

            this.api_success = 'Status changed Successfully';
            this.getAccountDetailsById();
          },
          (error) => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
          }
        );

    }
    else {
      this.status = 'Disable';
      this.api_error = '';
      this.api_success = '';
      this.disableConfirmbtn = true;
      this.accountService.changeFormSettings(this.accountId, this.status)
        .subscribe(
          data => {

            this.api_success = 'Status changed Successfully';
            this.getAccountDetailsById();
          },
          (error) => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
          }
        );

    }
    // if(this.licenseDetails.stmtCreatedBySystem){
    //   e.source.checked = true;

    // }
    // else if(!this.licenseDetails.stmtCreatedBySystem){
    //   e.source.checked = false;
    // }

  }
  createConsentForm() {
    const dialogRef = this.dialog.open(CreateConsentFormComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'action': 'create' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getConsentForm()
    });
  }
  editConsentform(form) {
    const dialogRef = this.dialog.open(CreateConsentFormComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'action': 'update', 'data': form.id }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getConsentForm()
    });
  }
  changeStatus(form) {
    const dialogRef = this.dialog.open(ChangeFormStatusComponent, {
      width: '600px',
      height: '300px',
      data: { 'accountId': this.accountId, 'status': form.status, 'id': form.id }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getConsentForm()
    });
  }
}
